import { useTranslation } from 'react-i18next';
import logoRounded from '@assets/images/logo-rounded.webp';
import salesNetworkMap from '@assets/images/sales-network-map.svg';
import Collapsible from '@layouts/main-layout/footer/collapsible/Collapsible';
import About from '@layouts/main-layout/footer/footer-menu/About';
import Order from '@layouts/main-layout/footer/footer-menu/Order';
import { useIsSmallScreen } from '@hooks/is-small-screen/useIsSmallScreen';
import { Link } from 'react-router';
import { NavigateRoutes } from '@features/routing/routesObject';
import { SALES_NETWORK_LANGUAGES } from '@@/languageConfig';



const Footer = () => {
	const { t } = useTranslation('web');

	const isSmallScreen = useIsSmallScreen();

	return (
		<div className='app-footer'>

			{!isSmallScreen &&
				<div className='footer-section about-us-section'>
					<h3>{t('layouts.footer.aboutHeader')}</h3>
					<About />
				</div>}

			{!isSmallScreen &&
				<div className='footer-section about-order-section'>
					<h3>{t('layouts.footer.orderHeader')}</h3>
					<Order />
				</div>}
			
			{SALES_NETWORK_LANGUAGES && SALES_NETWORK_LANGUAGES.length > 0 &&
				<div className='footer-section map-section'>
					<h3>{t('layouts.footer.mapHeader')}</h3>
					<Link to={NavigateRoutes.salesNetwork} className='disable-selection'>
						<img src={salesNetworkMap} alt='sales network map' />
					</Link>
				</div>
			}

			{isSmallScreen &&
				<Collapsible label={t('layouts.footer.aboutHeader')} className='about-us-section'>
					<About />
				</Collapsible>}

			{isSmallScreen &&
				<Collapsible label={t('layouts.footer.orderHeader')} className='about-order-section'>
					<Order />
				</Collapsible>}

			<div className='rounded-logo-wrapper'>
				<img src={logoRounded} alt='footer-logo-rounded' />
			</div>
			
		</div>
	);
}

export default Footer;